// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");

function makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, lotSizeUnit, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        baths: baths,
        beds: beds,
        halfBaths: halfBaths,
        livingArea: livingArea,
        lotSize: lotSize,
        lotSizeUnit: lotSizeUnit
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making singleFamilyAttributes"
    };
  }
}

function makeCondoAttributesInput(beds, baths, halfBaths, lotSize, lotSizeUnit, livingArea, parkingSpaces, parkingDetails) {
  if (beds !== undefined && baths !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        baths: baths,
        beds: beds,
        halfBaths: halfBaths,
        livingArea: livingArea,
        lotSize: lotSize,
        lotSizeUnit: lotSizeUnit,
        parkingDetails: parkingDetails,
        parkingSpaces: parkingSpaces
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making condoAttributesInput"
    };
  }
}

function makeLotAttributesInput(lotSize, lotSizeUnit) {
  if (lotSize !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        lotSize: lotSize,
        lotSizeUnit: lotSizeUnit
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making lotAttributesInput"
    };
  }
}

function makeMultiUnitAttributesInput(numberOfUnits) {
  if (numberOfUnits !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        numberOfUnits: numberOfUnits
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making multiUnitAttributesInput"
    };
  }
}

function make(propertyType, beds, baths, halfBaths, lotSize, lotSizeUnit, livingArea, numberOfUnits, parkingSpaces, parkingDetails) {
  if (propertyType === "Condo") {
    return Stdlib_Result.map(makeCondoAttributesInput(beds, baths, halfBaths, lotSize, lotSizeUnit, livingArea, parkingSpaces, parkingDetails), condo => ({
      condo: condo
    }));
  } else if (propertyType === "Lot") {
    return Stdlib_Result.map(makeLotAttributesInput(lotSize, lotSizeUnit), lot => ({
      lot: lot
    }));
  } else if (propertyType === "MultiUnit") {
    return Stdlib_Result.map(makeMultiUnitAttributesInput(numberOfUnits), multiUnit => ({
      multiUnit: multiUnit
    }));
  } else {
    return Stdlib_Result.map(makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, lotSizeUnit, livingArea), singleFamily => ({
      singleFamily: singleFamily
    }));
  }
}

let Schema;

exports.Schema = Schema;
exports.makeSingleFamilyAttributesInput = makeSingleFamilyAttributesInput;
exports.makeCondoAttributesInput = makeCondoAttributesInput;
exports.makeLotAttributesInput = makeLotAttributesInput;
exports.makeMultiUnitAttributesInput = makeMultiUnitAttributesInput;
exports.make = make;
/* No side effect */
